"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * (c) 2021, Micro:bit Educational Foundation and contributors
 *
 * SPDX-License-Identifier: MIT
 */
const React = require("react");
const logging_1 = require("./logging");
const theme_1 = require("./theme");
const squareLogo_svg_1 = require("./squareLogo.svg");
const horizontalLogo_svg_1 = require("./horizontalLogo.svg");
const defaultDeployment = {
    chakraTheme: theme_1.default,
    logging: new logging_1.NullLogging(),
    squareLogo: React.createElement(squareLogo_svg_1.ReactComponent, null),
    horizontalLogo: React.createElement(horizontalLogo_svg_1.ReactComponent, null),
    guideLink: "https://calliope.cc/programmieren/editoren/python",
    termsOfUseLink: "https://calliope.cc/nutzungshinweise",
    dataProtectionLink: "https://calliope.cc/dataprotection",
    imprintLink: "https://calliope.cc/impressum",
};
exports.default = defaultDeployment;
